import { options as configOptions } from './column-chart.options';
import { GenericChart } from './generic-chart';

export class ColumnChart extends GenericChart {
    presetsConfig = configOptions;
}
